import * as types from './actionsTypes';

export type SaveExtraActionType = {
  type: string;
  kind: string;
  price: string | number;
  headers: any;
  onSuccess?: () => void;
};

export const saveExtraAction = (
  kind: string,
  price: string | number,
  headers: any,
  onSuccess?: () => void
): SaveExtraActionType => ({
  type: types.SAVE_NEW_EXTRA,
  kind,
  price,
  headers,
  onSuccess,
});
